
import { WebServiceResponse } from 'app/services/WebServiceBase'

interface INosyParker {
  operationIsStarting()
  operationHasCompleted(wr: WebServiceResponse)
  operationHasFailed(wr: WebServiceResponse)
}

const nullNosyParker: INosyParker = {
  operationIsStarting: () => { /**/ },
  operationHasCompleted: (wr: WebServiceResponse) => { /**/ },
  operationHasFailed: (wr: WebServiceResponse) => { /**/ },
}

export {
  INosyParker,

  nullNosyParker
}



// WEBPACK FOOTER //
// ./src/app/utils/nosyParker/index.ts